export default class LegEntity {
  distributorId: number;
  repDid?: number;
  volume: number;
  picture: string;
  name: string;
  leg: number;
  QV: number;

  constructor(data: any = {}) {
    this.distributorId = data.distributor_id || data.distributorId;
    this.repDid = data.rep_did || data.repDid;
    this.volume = data.volume;
    this.picture = data.picture;
    this.name = data.name;
    this.leg = data.leg;
    this.QV = data.QV;
  }
}
